import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Justify } from "react-bootstrap-icons";
import "./Lunch_Break.css";
import { useNavigate } from "react-router-dom";
import { post_add_user_logs_status_api } from "../../api";
import ConfirmationModal from "../Confirmation Modal/ConfirmationModal";

const Lunch_Break_Started = () => {
    const navigate = useNavigate();

    const Lunch_Break_Before_Take_Img = "https://attc.aqato.com.au/public/Logos/lunch_imgs/21724938_6509116.jpg";
    const Lunch_Break_After_Take_Img = "https://attc.aqato.com.au/public/Logos/lunch_imgs/21724938_6509116.jpg";

    
    const [showConfirmationModalForResumeWork, setShowConfirmationModalForResumeWork] = useState(false);
    const [pageBanner, setPageBanner] = useState(Lunch_Break_After_Take_Img);
    const [isLunchBreakStarted, setIsLunchBreakStarted] = useState(true);

    const moveToPreviousPage = () => {
        navigate(-1);
    }

    const showStartLunchBreakScreen = () => {
        setPageBanner(Lunch_Break_After_Take_Img);
        setIsLunchBreakStarted(true);



    }






    const pre_post_add_user_logs_status_api = async (user_status) => {
        const formData = new FormData();

        formData.append("user_status", user_status);

        try {

              const response = await post_add_user_logs_status_api(
                formData
              );
              
              if (
                response &&
                response?.data &&
                response?.data?.response &&
                response?.data?.response?.response === true &&
                response?.data?.response?.data
              ) {
                console.log(response);
              } else {
                
                console.error(
                  "Error",
                  response?.data?.error_msg || "Unknown error"
                );
                
              }
            } catch (error) {

              console.error("Error in deleting", error);
            }
    }


    var count = 1;


    const [timeLeft, setTimeLeft] = useState(0);

    useEffect(() => {
        const initOrGetEndTime = () => {
            let endTime = localStorage.getItem('lunch_end_time');
            if (!endTime) {
                const now = Date.now();
                endTime = now + 3600 * 1000; // 1 hour from now
                localStorage.setItem('lunch_end_time', endTime);
            }
            return parseInt(endTime, 10);
        };

        let endTime = initOrGetEndTime();

        const updateTimer = () => {
            const now = Date.now();
            const diff = Math.max(0, Math.floor((endTime - now) / 1000));
            setTimeLeft(diff);
        };

        // Initial timer update
        updateTimer();

        const interval = setInterval(updateTimer, 1000);

        // Listen to changes in localStorage from other tabs
        const handleStorageChange = (e) => {
            if (e.key === 'lunch_end_time') {
                endTime = parseInt(e.newValue, 10);
                updateTimer();
            }
        };

        window.addEventListener('storage', handleStorageChange);

        return () => {
            clearInterval(interval);
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    const formatTime = (seconds) => {
        const h = Math.floor(seconds / 3600);
        const m = Math.floor((seconds % 3600) / 60);
        const s = seconds % 60;
        return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
    };

    const stopLunchBreak = async() => {
        setPageBanner(Lunch_Break_Before_Take_Img);
        setIsLunchBreakStarted(false);
        localStorage.removeItem("user_status");

        const userId = localStorage.getItem('AQATO_SuperAdminID');
        const channel = new BroadcastChannel('user-status-channel');
        channel.postMessage({ type: 'go_back_original_url', userId });
        if(count > 1){
            await pre_post_add_user_logs_status_api('online');
        }
        count++;
        navigate(-1);
        // navigate(-1);
        


    }

    useEffect(() => {
        const checkLunchBreakGoing = localStorage.getItem("user_status");

        if(checkLunchBreakGoing === "lunch"){
            setIsLunchBreakStarted(true);
            showStartLunchBreakScreen();
        }
    }, []);

    return (
        <>
            <div className="main_desktop">
                <hr className="mb-2 thick-hr" />

                <div className="main-heading-title container">

                    <div className="main_wrapper_lunch mt-5">
                        <div className="image_lunch_wrapper">
                            <img src={pageBanner} />
                            <p className="text-center font-weight-bold h4 mt-2">Time Left: {formatTime(timeLeft)}</p>
                        </div>
                        <div className="text-warpper-lunch mt-3">
                            
                            <div className="action_buttons_lunch text-center mt-3">
                            <button type="button" title="Stop Break" className="ml-1 mr-1 btn btn-danger"
                                        onClick={() => {
                                            setShowConfirmationModalForResumeWork(true);
                                        }}
                                    >
                                        <i class="bi bi-stop-circle-fill" /> Resume Work
                                    </button>
                                


                            </div>
                        </div>
                    </div>


                </div>


            </div>
            {showConfirmationModalForResumeWork && (
                <ConfirmationModal
                show={showConfirmationModalForResumeWork}
                onHide={() =>{
                    setShowConfirmationModalForResumeWork(false);
                }}
                onConfirm={() => {
                    setShowConfirmationModalForResumeWork(false);
                    stopLunchBreak();
                    stopLunchBreak();
                    localStorage.removeItem("lunch_end_time");
                }}
                title="Confirm Resume Work"
                message="Are you sure you want to Resume Work?"
            />
            )}                      
            
        </>
    );
};

export default Lunch_Break_Started;
